import { IntegrationUsageLogColumnKeyEnum, IntegrationUsageLogStatus } from 'src/api';
import { SelectFieldOption } from 'src/types/components';

export const INTEGRATION_USAGE_LOG_ENDPOINTS = {
  employment: '/v1/verifications/employment',
  income: '/v1/verifications/income',
  government: '/v1/verifications/government',
} as const;

type IntegrationUsageLogEndpoint =
  (typeof INTEGRATION_USAGE_LOG_ENDPOINTS)[keyof typeof INTEGRATION_USAGE_LOG_ENDPOINTS];

export const INTEGRATION_USAGE_LOG_ENDPOINT_LABELS: Record<IntegrationUsageLogEndpoint, string> = {
  [INTEGRATION_USAGE_LOG_ENDPOINTS.employment]: 'Employment',
  [INTEGRATION_USAGE_LOG_ENDPOINTS.income]: 'Income',
  [INTEGRATION_USAGE_LOG_ENDPOINTS.government]: 'Government',
};

export const INTEGRATION_USAGE_LOG_ENDPOINT_FILTER_OPTIONS = [
  {
    value: INTEGRATION_USAGE_LOG_ENDPOINTS.employment,
    label: INTEGRATION_USAGE_LOG_ENDPOINT_LABELS[INTEGRATION_USAGE_LOG_ENDPOINTS.employment],
  },
  {
    value: INTEGRATION_USAGE_LOG_ENDPOINTS.income,
    label: INTEGRATION_USAGE_LOG_ENDPOINT_LABELS[INTEGRATION_USAGE_LOG_ENDPOINTS.income],
  },
  {
    value: INTEGRATION_USAGE_LOG_ENDPOINTS.government,
    label: INTEGRATION_USAGE_LOG_ENDPOINT_LABELS[INTEGRATION_USAGE_LOG_ENDPOINTS.government],
  },
] as const satisfies SelectFieldOption[];

export const INTEGRATION_USAGE_LOG_STATUS_LABELS: Record<IntegrationUsageLogStatus, string> = {
  [IntegrationUsageLogStatus.Processing]: 'Processing',
  [IntegrationUsageLogStatus.FileUpload]: 'File Upload',
  [IntegrationUsageLogStatus.Succeeded]: 'Succeeded',
  [IntegrationUsageLogStatus.Failed]: 'Failed',
};

export const INTEGRATION_USAGE_LOG_STATUS_FILTER_OPTIONS = [
  {
    value: IntegrationUsageLogStatus.Processing,
    label: INTEGRATION_USAGE_LOG_STATUS_LABELS[IntegrationUsageLogStatus.Processing],
  },
  {
    value: IntegrationUsageLogStatus.FileUpload,
    label: INTEGRATION_USAGE_LOG_STATUS_LABELS[IntegrationUsageLogStatus.FileUpload],
  },
  {
    value: IntegrationUsageLogStatus.Succeeded,
    label: INTEGRATION_USAGE_LOG_STATUS_LABELS[IntegrationUsageLogStatus.Succeeded],
  },
  {
    value: IntegrationUsageLogStatus.Failed,
    label: INTEGRATION_USAGE_LOG_STATUS_LABELS[IntegrationUsageLogStatus.Failed],
  },
] as const satisfies SelectFieldOption[];

export const INTEGRATION_USAGE_LOG_FILTER_IDS = {
  createdAtFrom: 'createdAtFrom',
  createdAtTo: 'createdAtTo',
  endpoint: 'endpoint',
  status: 'status',
} as const;

type IntegrationUsageLogExportColumn = {
  key: IntegrationUsageLogColumnKeyEnum;
  label: string;
};

export const INTEGRATION_USAGE_LOG_EXPORT_COLUMNS: IntegrationUsageLogExportColumn[] = [
  { key: 'createdAt', label: 'Requested At' },
  { key: 'duration', label: 'Duration' },
  { key: 'endpoint', label: 'Endpoint' },
  { key: 'requestId', label: 'Request ID' },
  { key: 'status', label: 'Status' },
  { key: 'verified', label: 'Verified' },
  { key: 'ambiguous', label: 'Ambiguous match' },
  { key: 'noMatch', label: 'No Match' },
  { key: 'statusCode', label: 'HTTP Code' },
  { key: 'requesterId', label: 'Requester ID' },
  { key: 'last4Ssn', label: 'Last 4 SSN' },
  { key: 'dateOfBirth', label: 'DOB' },
];
